import { action as apiAction } from 'api/Api'
import {
  set as setCard
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'
import sweetalert from 'sweetalert2'

type Payload = {
  id: number
  listId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { id } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCard({
    id,
    listId: null,
    isArchived: true,
  }))

  try {
    await apiAction('ArchiveCard', {
      cardId: id
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 539) { // Card is blocked
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
